<script setup lang="ts">
import { watch } from 'vue'
import { useTheme } from 'vuetify'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import { hexToRgb } from '@layouts/utils'
import ReloadPWA from "@/components/ReloadPWA.vue";
import { useAppStore } from '@/store/app'

const { syncInitialLoaderTheme, syncVuetifyThemeWithTheme: syncConfigThemeWithVuetifyTheme, isAppRtl } = useThemeConfig()

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
syncInitialLoaderTheme()
syncConfigThemeWithVuetifyTheme()

const appStore = useAppStore()

watch(() => appStore.user, (user) => {
  if (!user || !window.$crisp) return
  if (user.email) window.$crisp.push(['set', 'user:email', [user.email]])
  if (user.servicePhone) window.$crisp.push(['set', 'user:phone', [user.servicePhone]])
}, { immediate: true })
</script>

<template>
  <VLocaleProvider :rtl="isAppRtl">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
        <ReloadPWA />
      <RouterView />
    </VApp>
  </VLocaleProvider>
</template>
